import { t } from "i18next";
import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import ButtonPage from "../button/ButtonPage";

function ViewcartboxPage(props) {

  const navigate = useNavigate()

  const navigateTocart = () => {
    navigate("/cart");
  };

  return (
    props?.cartdata?.length === 0 ? (
      <></>
    ) : (
      <div className="col-12 viewcart-box">
        <div>
          <h5 className="total-item">
            {t("pages.Item total")} | {Number(
              typeof props?.amount?.total_amount === "undefined"
                ? "00.00"
                : props?.amount?.total_amount +
                (typeof props?.amount?.charges === "undefined"
                  ? 0
                  : props?.amount?.charges) -
                (typeof props?.amount?.discount ===
                  "undefined"
                  ? 0
                  : props?.amount?.discount)
            ).toFixed(2)}{" "}
            {process.env.REACT_APP_CURRENCY_SYMBOL}
          </h5>
        </div>
        <div>
          <ButtonPage
            onClick={() => navigateTocart()}
            Text={
              t("pages.View cart")
            }
            className={`button-submit m-2 hover-btn btn-viewcart`}
            type={"submit"}
          />
        </div>
      </div>
    )
  )
}

const mapStateToProps = (state) => ({
  cartdata: state?.home?.cartdata,
  amount: state?.home?.amount,
});

export default connect(mapStateToProps)(ViewcartboxPage);